import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import { SOCIAL_OAUTH_CALLBACK_PATH } from "@/api/socialOAuth";

export const ROUTE_NAMES = {
  goods: "goods",
  goodNew: "good-new",
  goodNewAi: "good-new-ai",
  goodDetail: "good-detail",
  recommendations: "recommendations",
  settings: "settings",
  successPayment: "successpayment",
  socialOAuthCallback: "social-oauth-callback",
} as const;

export type RouteName = (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES];

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: ROUTE_NAMES.goods,
    component: () => import("@/pages/goods/Goods.vue"),
    meta: { title: "CardGenius - Контент", standalone: false },
  },
  {
    path: "/goods/new",
    name: ROUTE_NAMES.goodNew,
    component: () => import("@/pages/goods/Goods.vue"),
    meta: { title: "CardGenius — Создание", standalone: false },
  },
  {
    path: "/goods/new/ai",
    name: ROUTE_NAMES.goodNewAi,
    component: () => import("@/pages/goods/Goods.vue"),
    meta: { title: "CardGenius — Создание (AI)", standalone: false },
  },
  {
    path: "/goods/:goodId",
    name: ROUTE_NAMES.goodDetail,
    component: () => import("@/pages/goods/Goods.vue"),
    meta: { title: "CardGenius - Товар", standalone: false },
  },
  {
    path: "/recommendations",
    name: ROUTE_NAMES.recommendations,
    component: () => import("@/pages/recommendations/Recommendations.vue"),
    meta: { title: "CardGenius - Рекомендации", standalone: false },
  },
  {
    path: "/settings",
    name: ROUTE_NAMES.settings,
    component: () => import("@/pages/settings/Settings.vue"),
    meta: { title: "CardGenius - Настройки", standalone: false },
  },
  {
    path: "/successpayment",
    name: ROUTE_NAMES.successPayment,
    component: () => import("@/pages/billing/SuccessPaymentPage.vue"),
    meta: { title: "CardGenius", standalone: true },
  },
  {
    // OAuth-редирект от Google. Маршрут существует, чтобы catch-all не сбросил URL
    // до того, как LoginScreen / App.vue прочитают id_token из window.location.
    // Контент рендерим как у корня — после parseSocialCallback() URL очищается на "/".
    path: SOCIAL_OAUTH_CALLBACK_PATH,
    name: ROUTE_NAMES.socialOAuthCallback,
    component: () => import("@/pages/goods/Goods.vue"),
    meta: { title: "CardGenius", standalone: false },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: ROUTE_NAMES.goods },
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  const title = (to.meta?.title as string | undefined) ?? "CardGenius";
  if (typeof document !== "undefined") {
    document.title = title;
  }
});
